import React, { useState, useEffect } from "react";

import { Grid, Typography } from "@material-ui/core";

import MapContainer from "./MapContainer";

export default (props) => {
    const [report, setReport] = useState(props.report);

    useEffect(() => {
        setReport(props.report);
    }, [props.report]);
    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Toolbox Talk Location:
            </Typography>
            {report && (
                <MapContainer
                    lat={report.location_lat}
                    long={report.location_lon}
                />
            )}
        </Grid>
    );
};
